import React from 'react';
import { Input, Tooltip } from 'antd';
import "./EyePlotConfig.css"
import { numberCheck } from '../../../../services/helper/dataProcess';
import { splitValueBlankUnit } from '../../../../services/helper/numberHelper';

/**
 * @param {*} props { eyePlotConfig: {ui_before_trigger, ui_after_trigger, waveform_start, waveform_end} }
 */
class EyePlotConfig extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editInputInfo: {
        type: "",
        value: "",
        unit: ""
      },
      error: {
        type: "",
        info: ""
      }
    };
    this.refInput = {};
  }

  onChangeEditInputInfo = (editInputInfo) => {
    this.setState({ editInputInfo: { ...this.state.editInputInfo, ...editInputInfo } }, () => {
      const { editInputInfo } = this.state;
      if (this.refInput && this.refInput[editInputInfo.type]) {
        this.refInput[editInputInfo.type].focus();
      }
    });
  }

  onSaveValue = (e) => {
    const { eyePlotConfig } = this.props;
    const { editInputInfo } = this.state;
    const { type, value, unit } = editInputInfo;
    // It should not be of the type of waveform_start and waveform_end; it must be a number.
    let numberError = value || !["waveform_start", "waveform_end"].includes(type) ? numberCheck(value, true) : null;
    let error = null;
    if (numberError) {
      error = numberError;
    } else if (value && Number(value) < 0) { // It must be greater than 0.
      error = `Value must be greater than 0.`;
    } else if ((type === "waveform_start" || type === "waveform_end") && value) {
      const otherType = type === "waveform_start" ? "waveform_end" : "waveform_start";
      const { value: otherValue } = splitValueBlankUnit(eyePlotConfig[otherType]);
      if (type === "waveform_end" && otherValue && Number(value) <= Number(otherValue)) { // end must be greater than start
        error = `Value must be greater than ${eyePlotConfig[otherType]}.`;
      } else if (type === "waveform_start" && otherValue && Number(value) >= Number(otherValue)) { // start must be less than end
        error = `Value must be less than ${eyePlotConfig[otherType]}.`;
      }
    }

    if (error) {
      if (this.refInput && this.refInput[editInputInfo.type]) {
        this.refInput[editInputInfo.type].focus();
      }
      this.setState({ error: { type, info: error }, editInputInfo });
      return;
    }

    e && e.target && e.target.blur();
    this.setState({ editInputInfo: {}, error: { type: "", info: "" } });
    if (!type) return;
    this.props.onChange("eyePlotConfig", { ...eyePlotConfig, [type]: unit && !isNaN(value) ? `${value} ${unit}` : value });
  }

  render() {
    const { eyePlotConfig } = this.props;
    const { editInputInfo, error } = this.state;
    return <>
      <div className='eye-edit-item-size-box'>
        {[{ type: "text-1", value: "Using the waveform from" },
        { type: "waveform_start", value: eyePlotConfig.waveform_start },
        { type: "text-2", value: "to" },
        { type: "waveform_end", value: eyePlotConfig.waveform_end },
        { type: "text-3", value: "to plot the eye diagram" }].map(item => {
          if (item.type === "waveform_start" || item.type === "waveform_end") {
            const { value, unit = "ns" } = splitValueBlankUnit(item.value);
            const isError = error.type === item.type && !!error.info;
            return <span key={item.type} className='span-input-box'>
              <Tooltip
                title={error.info}
                open={isError}
                classNames={{ root: "andes-v2-tooltip-error" }}
              >
                <Input
                  placeholder={item.type === 'waveform_start' ? 'start' : 'end'}
                  size="small"
                  value={editInputInfo.type === item.type ? editInputInfo.value : value}
                  addonAfter={value || editInputInfo.type === item.type ? unit : ""}
                  onFocus={() => this.onChangeEditInputInfo({ type: item.type, value, unit })}
                  onChange={(e) => this.onChangeEditInputInfo({ value: e.target.value })}
                  onPressEnter={(e) => this.onSaveValue(e)}
                  onBlur={() => this.onSaveValue()}
                  ref={(ref) => this.refInput[item.type] = ref}
                />
              </Tooltip>
            </span>
          } else {
            return <span key={item.type}>{item.value}</span>
          }
        })}
      </div>
      <div className='eye-plot-edit-range-box'>
        <img src={'/lib/imgs/cphy_eye_mask.webp'} style={{ width: '100%' }} alt="" />
        <div className="eye-edit-item-range-box">
          <svg width="660" height="60" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <marker id="triangle-end" markerUnits="strokeWidth" markerWidth="10" markerHeight="8" refX="0" refY="4" orient="auto">
                <path d="M 0 0 L 10 4 L 0 8 z"></path>
              </marker>
              <marker id="triangle-start" markerUnits="strokeWidth" markerWidth="10" markerHeight="8" refX="0" refY="4" orient="auto-start-reverse">
                <path d="M 0 0 L 10 4 L 0 8 z"></path>
              </marker>
            </defs>
            {/* d="M 95,40 L 530,40" */}
            <path d="M 10,40 L 512,40" stroke="#000" strokeWidth="1" fill="none" markerStart="url(#triangle-start)" markerEnd="url(#triangle-end)"></path>
            {/* x1="542" x2="542" */}
            <line x1="526" x2="526" y1="0" y2="50" stroke="#000" strokeWidth="1" strokeDasharray="5 2"></line>
            {/* d="M 554,40 L 650,40" */}
            <path d="M 540,40 L 650,40" stroke="#000" strokeWidth="1" fill="none" markerStart="url(#triangle-start)" markerEnd="url(#triangle-end)"></path>
          </svg>
          {["ui_before_trigger", "ui_after_trigger"].map(item => {
            const type = item === "ui_before_trigger" ? "before" : "after";
            const isError = error.type === item && !!error.info;
            return <span className={`eye-edit-item-${type}`} key={item}>
              <Tooltip
                title={error.info}
                open={isError}
                classNames={{ root: "andes-v2-tooltip-error" }}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                destroyOnHidden
              >
                <Input
                  addonAfter="UI"
                  size="small"
                  value={editInputInfo.type === item ? editInputInfo.value : eyePlotConfig[item]}
                  onFocus={() => this.onChangeEditInputInfo({ type: item, value: eyePlotConfig[item] })}
                  onChange={(e) => this.onChangeEditInputInfo({ value: e.target.value })}
                  onPressEnter={(e) => this.onSaveValue(e)}
                  onBlur={() => this.onSaveValue()}
                  ref={(ref) => this.refInput[item] = ref}
                />
              </Tooltip>
            </span>
          })}
        </div>
      </div>
    </>;
  }
}

export default EyePlotConfig;